import { render, staticRenderFns } from "./CardsOverview.vue?vue&type=template&id=b8ab1b3a&scoped=true"
import script from "./CardsOverview.vue?vue&type=script&lang=ts"
export * from "./CardsOverview.vue?vue&type=script&lang=ts"
import style0 from "./CardsOverview.vue?vue&type=style&index=0&id=b8ab1b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ab1b3a",
  null
  
)

export default component.exports